module.exports = __webpack_public_path__ + "img/product_11.f7b5a5d.webp";